import { useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';



const useModifiedDynamicDataErrors = (currentTemplateId, template, initialErrors, language) => {
  return useMemo(() => {
    if (!currentTemplateId || isEmpty(template) || !initialErrors?.data) {
      return initialErrors;
    }

    const modifiedErrors = { ...initialErrors };

    template?.fields?.data.forEach((field) => {
      if (modifiedErrors.data[field.full_name]) {
        const regex = /(The\s)(.*?)(\sfield)/;
        const replacement = field[`title_${language}`];

        modifiedErrors.data[field.full_name].value = modifiedErrors
          .data[field.full_name]
          .value
          .replace(regex, `$1${replacement}$3`);
      }
    });

    return modifiedErrors;
  }, [ currentTemplateId, template, initialErrors, language ]);
};

export default useModifiedDynamicDataErrors;
